export default __webpack_public_path__ + "static/media/gallery_02.29388a17.jpg";